import { EditPrimaryContactForm, EditPrimaryContactModal } from "@components/EditPrimaryContactModal";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUserPermission } from "@helpers/userPermissionHelper";
import { updateOrganization } from "@store/organizationSlice";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { LBtn } from "../../../../../common/components/LBtn";
import { LModal } from "../../../../../common/components/LModal";
import { Organization } from "../../../../../common/helpers/organizationHelper";
import { EditAccountDetailHeader } from "./EditAccountDetailHeader";
import { EditAccountDetailModal } from "./EditAccountDetailModal";

const Field = (props: { text: string; label: string }): JSX.Element => {
    return (
        <div className="column is-one-third field mr-6">
            <label className="label is-small has-text-grey-light">{props.label}</label>
            <div className="has-text-weight-bold">
                <div>{props.text}</div>
            </div>
        </div>
    );
};

export const AccountDetails = ({ organization }: AccountDetailsProps): JSX.Element => {
    const [isAccountDetailsModalOpen, setIsAccountDetailsModalOpen] = useState(false);
    const [isPrimaryContactModalOpen, setIsPrimaryContactModalOpen] = useState(false);

    const { isClinicalAdmin } = useUserPermission({});

    const dispatch = useDispatch();

    const handleOnEditOrganization = (): void => {
        setIsAccountDetailsModalOpen(!isAccountDetailsModalOpen);
    };

    const handleEditPrimaryContactClick = (): void => {
        setIsPrimaryContactModalOpen((isOpen) => !isOpen);
    };

    const handleSubmitEditPrimaryContact = (updatedPrimaryContact: EditPrimaryContactForm): void => {
        dispatch(
            updateOrganization({
                ...organization,
                primaryContact: updatedPrimaryContact
            })
        );
    };

    return (
        <>
            <h1 className="title is-5 mt-5">Overview</h1>
            <div className="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center">
                <div className="is-size-5 has-text-ldark-gray">Account Details</div>
                {isClinicalAdmin && (
                    <LBtn variation="unstyled" onClick={handleOnEditOrganization}>
                        <FontAwesomeIcon className="px-1" icon={solid("pen-to-square")} /> Edit Account Details
                    </LBtn>
                )}
            </div>
            <div className="divider" />
            <div>
                <div className="columns">
                    <Field text={organization.orgName} label="Organization Name" />
                </div>

                <div className="columns">
                    <Field
                        text={`${organization.primaryContact?.firstName} ${organization.primaryContact?.lastName}`}
                        label="Primary Contact Name"
                    />
                    <Field text={organization.primaryContact?.email ?? ""} label="Primary Contact Email" />
                </div>
            </div>
            <a className="has-text-weight-bold is-size-7" onClick={handleEditPrimaryContactClick}>
                Edit Primary Contact
            </a>
            {isAccountDetailsModalOpen && (
                <LModal
                    title={<EditAccountDetailHeader />}
                    onClose={handleOnEditOrganization}
                    fullHeight={false}
                    width="s"
                >
                    <EditAccountDetailModal />
                </LModal>
            )}
            {isPrimaryContactModalOpen && (
                <EditPrimaryContactModal
                    organization={organization}
                    onSubmit={handleSubmitEditPrimaryContact}
                    onClose={handleEditPrimaryContactClick}
                />
            )}
        </>
    );
};

interface AccountDetailsProps {
    organization: Organization;
}
